export const environment = {
    production: false,

    // API: 'https://localhost:44374/api/',
    // API: 'https://api.banquei.com.br/api/',
    // API: 'https://api.banquei.com.br/api/
    API: 'https://api.banquei.com.br/monolito/api/',
    // API: 'https://hmlg-api.banquei.com.br/monolito/api/',
    // API: 'https://localhost:44374/api/',
    // API: 'https://api.banquei.com.br/api/',
    // GATEWAY: 'https://api.banquei.com.br/',
    // GATEWAY: 'https://api.banquei.com.br/',
    GATEWAY: 'https://api.banquei.com.br/',
    EXTRACT: 'https://api.banquei.com.br/lambda/extrato/cedente',
    AUTH_LOGIN: 'https://api.banquei.com.br/lambda/auth',
    AUTH_REFRESH_TOKEN: 'https://api.banquei.com.br/lambda/auth/refreshtoken',
    TOTAL_CARACTERE_CNPJ: 14,
    TOTAL_CARACTERE_CPF: 11,
    DURACAO_PEDIDO_ALERTA: 600000
};
